function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    new Swiper('.mySwiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 20,
      slidesPerView: 'auto',
      freeMode: true,
      speed: 3000, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false
      }
    })
    new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
    // const tabs = $('.sp-tab')
    // let currentIndex = 0
    // function nextTabFunc() {
    //   const currentTab = tabs[currentIndex]
    //   currentTab.classList.add('sp-tab-ani')
    //   let nextIndex = (currentIndex + 1) % tabs.length
    //   const nextTab = tabs[nextIndex]
    //   setTimeout(() => {
    //     currentTab.classList.remove('sp-tab-ani')
    //   }, 2500),
    //     (currentIndex = (currentIndex + 1) % tabs.length),
    //     setTimeout(nextTabFunc, 1500)
    // }
    // nextTabFunc()
    // 数字框
    let prods = window.product
    function getCur() {
      console.log(1111)
      let color = $('#color div.active').attr('data-val')
      let size = $('#size div.active').attr('data-val')
      console.log(color)
      console.log(size)
      return prods.filter(item => item.option1 == color && item.option2 == size)[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
      $('.product-part .sp-frees .free').html(off_font)
    }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
      // $.post(
      //   '/api/checkout/order',
      //   {
      //     line_items: [
      //       {
      //         quantity: $('#calcNumber').val(), // 数量
      //         variant_id: getCur().id, // 子商品id
      //         note: '' // 备注
      //       }
      //     ],
      //     refer_info: { source: 'buy_now' }
      //   },
      //   function (ret) {
      //     if (ret.state === 'success') {
      //       return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information')
      //     } else {
      //       $.toast.show({
      //         content:
      //           {
      //             30003: 'Some items have been removed, please re-order',
      //             line_items_variant_withdraw: 'Some items have been sold out, please re-order',
      //             line_items_variant_sold_out: 'Some items are not in stock, please re-order'
      //           }[ret.state] ||
      //           ret.errors[0] ||
      //           'Some items information has been updated, please re-order'
      //       })
      //     }
      //   }
      // )
    })
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })
    // style选项
    let typeOptions = $('#color .option')
    // 切换选项
    typeOptions.click(function () {
      var index = $(this).index()
      var index2 = $('#size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      changeOption(index, index2)
    })
    $('#size .option').click(function () {
      var index = $('#color .option.active').index()
      var index2 = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      changeOption(index, index2)
    })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250904-img4.png?v=1761202032',
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250904-img2.png?v=1759139468',
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250904-img3.png?v=1759139468',
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250513-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250513-pro-5.png',
      'https://cdn.shopify.com/s/files/1/0836/7672/5552/files/20250513-pro-6.png'
    ]
    function changeOption(index, index2) {
      if (index == 0) {
        $('.top-product img.sp-pro').attr('src', imgArr[index2])
      } else if (index == 1) {
        $('.top-product img.sp-pro').attr('src', imgArr[index2 + 3])
      }
      changePrice()
    }
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val()
        }
        $.post(
          '/api/cart',
          {
            product_id: getCur().product_id,
            variant_id: getCur().id,
            quantity: $('#calcNumber').val()
          },
          function (res) {
            $.get('/api/cart', function (res) {
              $('#cardNum').html(res.cart.item_count)
              $('.sp-cart .num').css('background', '#cf0101')
            })
          }
        )
        // if (number > 0) {
        //   $('.sp-cart .num').css('background', '#cf0101')
        // } else {
        //   $('.sp-cart .num').css('background', '#919191')
        // }
        var img = $('.top-product img.sp-pro')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99'
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 137,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
    // 文字标题动画
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll('span'),
        paragraph = gradually.querySelector('.sp-sub-title'),
        observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                spans.forEach((span, index) => {
                  ;(span.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (span.style.animationDelay = `${index * 0.15}s`)
                  const i = span.querySelector('i')
                  i &&
                    ((i.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (i.style.animationDelay = `${index * 0.15}s`))
                })
                const totalDelay = spans.length * 0.15 + 0.3
                paragraph &&
                  ((paragraph.style.animation = 'swift-up-fade 0.5s ease forwards'),
                  (paragraph.style.animationDelay = `${totalDelay}s`)),
                  observer.unobserve(gradually)
              }
            })
          },
          { threshold: 0.3 }
        )
      observer.observe(gradually)
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0
    }

    const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    }, config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('.sp-header-top').height() - $('.time-part').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth' // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
